import { Machine } from "xstate";

const activateAccountMachine = Machine({
  id: "activate-account",
  initial: "verify",
  states: {
    verify: {
      on: {
        RESOLVE: "idle",
        REJECT: "invalid",
      },
    },
    invalid: {
      type: "final",
    },
    idle: {
      on: {
        ACTIVATE: "loading",
      },
    },
    failure: {
      on: {
        ACTIVATE: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        REJECT: "failure",
      },
    },
    success: {
      type: "final",
    },
  },
});

export default activateAccountMachine;
